import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handleChangeValue, handlePatch } from '../../../../../utils/AxiosUtil';
import * as util from '../../../../../utils/Util';
import ErrorAwareAmountField from '../../../../common/inputfields/ErrorAwareAmountField';
import ErrorAwareDatePicker from '../../../../common/inputfields/ErrorAwareDatePicker';
import ErrorAwareTextField from '../../../../common/inputfields/ErrorAwareTextField';
import NewAgainField from '../../../../common/inputfields/NewAgainField';
import ErrorAwareTimePicker from '../../../../common/inputfields/ErrorAwareTimePicker';

class ModifyOccasionalSalary extends Component {

    state = {
        amount: this.props.row.amount,
        name: this.props.row.name,
        date: new Date(this.props.row.date),
        startTime: this.props.row.startTime,
        endTime: this.props.row.endTime,
        errors: new Map(),
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();

        const path = '/api/occasionalsalary';
        const requestObject = {
            "privateId": this.props.row.privateId,
            "publicId": this.props.row.publicId,
            "amount": util.toNumber(this.state.amount),
            "name": this.state.name,
            "date": this.state.date,
            "startTime": this.state.startTime,
            "endTime": this.state.endTime
        };
        // console.log(requestObject);
        handlePatch(path, requestObject, this);
    };
    componentDidMount() {
        console.log(this.props);
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            required
                            name="name"
                            label="Név"
                            errors={this.state.errors}
                            value={this.state.name}
                            prevValue={this.props.row.name}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareAmountField
                            required
                            name="amount"
                            label="Összeg"
                            errors={this.state.errors}
                            value={this.state.amount}
                            prevValue={this.props.row.amount}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            required
                            name="date"
                            label="Dátum"
                            errors={this.state.errors}
                            value={this.state.date}
                            prevValue={this.props.row.date}
                            onChange={v => handleChangeValue(v, "date", this)} />
                    </div>
                    <div className='input-group'></div>
                    <div className='input-group'>
                        <ErrorAwareTimePicker
                            required
                            name="startTime"
                            label="Kezdő időpont"
                            errors={this.state.errors}
                            value={this.state.startTime}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTimePicker
                            required
                            name="endTime"
                            label="Befejezés időpont"
                            errors={this.state.errors}
                            value={this.state.endTime}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                </div>
                <div className="form-actions">
                    <NewAgainField
                        checked={this.state.newAgain}
                        onChange={e => this.setState({ newAgain: e.target.checked })} />
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Mentés
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(ModifyOccasionalSalary);
